<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}" class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div
      :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big"
      id="pop_changeDate"
      style="display: block"
    >
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">4+1 정기구매 사은품 선택</span>
          <button class="rew19_basketList_btn" @click="onCancel">
            <span>닫기</span>
          </button>
        </h2>
      </div>
      <div class="rew19_popup_cont" v-if="giftData.isAgelocMe">
        <ul class="rew19_select_table">
            <li class="rew19_inselectBt_wrap">
                <div class="rew19_wrapRadio_t1">
                    <input
                        type="radio"
                        class="rew19_fakeRadio_t1"
                        name="defaultProduct"
                        id="ageloc_01"
                        value="Y"
                        v-model="giftData.defaultProduct"
                    />
                    <label for="ageloc_01"></label>
                </div>
                <h3 class="rew19_titleIndependence">기존 스킨케어 코드 선택 [{{giftData.defaultAgmCode}}]</h3>
                <ul class="rew19_dotList">
                    <li>장바구니 내 스킨케어 코드를 변경하실 경우 해당 스킨케어 코드도 함께 변경됩니다.</li>
                    <li>4회 유지 결제 전 다시 한 번 확인해 주세요.</li>
                    <li>장바구니에 커스텀 프로덕트 세트가 서로 다른 스킨 케어 코드로 2개 이상일 경우, 베이직 스킨케어 세트가 자동 선택됩니다.</li>
                </ul>
            </li> 
            <li class="rew19_inselectBt_wrap">
                <div class="rew19_wrapRadio_t1">
                    <input
                        type="radio"
                        class="rew19_fakeRadio_t1"
                        name="defaultProduct"
                        id="ageloc_02"
                        value="N"
                        v-model="giftData.defaultProduct"
                    />
                    <label for="ageloc_02"></label>
                </div>
                <ul class="rew19_transition_table">
                    <li>
                        <span class="with_type1">신규코드입력</span>
                        <div class="nogep_type"><a class="rew19_btn_border" @click="openSkinCareCodeListDialog">코드조회</a></div>
                    </li>
                    <li>
                        <em class="with_type1">이름</em>
                        <div class="rew19_form_full">
                            <input v-model.trim="giftData.agmName" title="사은품 이름" type="text" class="autoFocus onlynum rew19_inputTxt_t1" placeholder="">
                        </div>
                    </li>
                    <li>
                        <em class="with_type1">코드</em>
                        <div class="rew19_form_full">
                            <input v-model.trim="giftData.agmCode"  title="사은품 코드" type="text" class="autoFocus onlynum rew19_inputTxt_t1" placeholder="">
                        </div>
                    </li>
                    <li>
                        <em class="with_type1">코드 별명</em>
                        <div class="rew19_form_full">
                            <input 
                            v-model.trim="giftData.agmDetail" 
                            title="사은품 코드 별명" type="text" 
                            class="autoFocus onlynum rew19_inputTxt_t1" placeholder="" 
                            >
                        </div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>

      <div class="rew19_popup_cont" v-if="!giftData.isAgelocMe">
        <ul class="rew19_select_table">
          <li class="rew19_inselectBt_wrap" v-for="(item, idx) in viewData.giftList" :key="idx">
            <div class="rew19_wrapRadio_t1">
              <input
                type="radio"
                class="rew19_fakeRadio_t1"
                name="gift"
                :id="'giftList_' + idx"
                :value="item.productCode"
                v-model="giftData.productCode"
              />
              <label :for="'giftList_' + idx"></label>
            </div>
            <div class="rew19_payment_list__img">
              <img :src="item.productImage" alt title />
            </div>
            <h3 class="rew19_titleIndependence">{{item.productName}}</h3>
          </li>
        </ul>
      </div>
      <!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="clickOk">확인</button>
      </div>
    </div>

    <skin-care-code-list-dialog
      :show="skinCareCodeListDialogShow"      
      @close="setSkinCareCodeFromList"
      ref="skinCareCodeListDialog"
    ></skin-care-code-list-dialog>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import SkinCareCodeListDialog from '@/components/popup/SkinCareCodeListDialog';

export default {
  name: "AroCancelDialog",
  components: {SkinCareCodeListDialog},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,

      giftData : {},
      viewData : {},
      sendData : {}, 

      skinCareCodeListDialogShow : false,
      skinCareCodeListDialog : {},
      
    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {
      let _this = this;

      _this.$emit("close", response, response ? _this.sendData : null);
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(!_this.validation()){
        return;
      }

      _this.sendData = {..._this.giftData};
      /* if(_this.giftData.isAgelocMe){
        // agelocMe 


      }else{
        // !agelocMe 
      } */


      this.onClose(true);
    },

    /**
     * API Request
     */

    //카테고리 가져오기
    apiRetentionsGift : function(mSeq){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/retentions/gift`, {
        params: {mSeq : mSeq}
      });
    },

    /**
     * API Request
     */    
    //스킨코드 유무 검증
    apiCheckSkinCareCode(sCode){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/apiCheckSkinCareCode`, {
        params: {
          code: sCode
        }        
      });
    },


    /**
     * Local
     */
    initData: function(data) {
      let _this = this;

      _this.giftData = data;
      _this.loadData();
    
    },

    loadData(){
      let _this = this;

      if(!_this.giftData.isAgelocMe){
          //show loading
        _this.$showLoading();
        _this.apiRetentionsGift(_this.giftData.mSeq).then(res=>{
          if (res.status === 200 && res.data.status === "0000") {
            _this.viewData = {...res.data};
          }else{
          _this.$dialogs.alert(res.data.message).then(res => {});
          }

        }).catch(()=>{
            _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});        

        }).finally(()=>{
            //hide loading
            _this.$hideLoading();

        });
      }
    },

    //Open dialog 스킨 케어 코드 List
    openSkinCareCodeListDialog(){
      let _this = this;

      //pass data to dialog      
      _this.skinCareCodeListDialog = {
        ..._this.skinCareCodeListDialog,
        memberId : _this.giftData.memberId
      };
      
      _this.$refs.skinCareCodeListDialog.initData(_this.skinCareCodeListDialog);

      _this.skinCareCodeListDialogShow = true;
    },

    //스킨 케어 코드 변경
    setSkinCareCodeFromList(isOk, data){
      let _this = this;

      _this.skinCareCodeListDialogShow = false;      

      if(!isOk){
        //Do nothing
        return;
      }

      _this.giftData.agmCode = data.assessmentCode;
      _this.giftData.agmName = data.personName;
      _this.giftData.agmDetail = data.assessmentLabel;

      _this.giftData.defaultProduct = 'N';
    },

    validation(){
      //스킨 케어 코드 확인
      let _this = this;

      if(!_this.giftData.isAgelocMe){
        return true;
      }

      if(_this.giftData.defaultProduct == 'Y'){
        return true;
      }

      let agm_info = _this.giftData;
      let chVal = "";

      //스킨케어코드
      chVal = agm_info.agmCode;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 정보 입력이 반드시 필요합니다. 코드를 입력해주세요.")
        .then(res => {
          _this.$refs.agmCode.focus();
        });   
        return false;
      }

      let regExSkinCareCode = /^[A-Z0-9+]*$/;
      if(!regExSkinCareCode.test(chVal)){
        _this.$dialogs.alert("에이지락 미 커스텀 프로덕트 세트 주문 시에는 스킨 케어 코드는 영어 및 숫자만 가능합니다.")
        .then(res => {
          _this.$refs.agmCode.focus();
        });   
        return false;
      }

      //이름
      chVal = agm_info.agmName;
      if(!chVal || chVal.trim() == ""){
        _this.$dialogs.alert("스킨케어 코드 이름을 입력해 주세요.")
        .then(res => {
          _this.$refs.agmName.focus();
        });   
        return false;
      }

      // //코드 별병
      // chVal = agm_info.agm_detail;
      // if(!chVal || chVal.trim() == ""){
      //   _this.$dialogs.alert("스킨케어 코드별명을 입력해 주세요.")
      //   .then(res => {
      //     _this.$refs.agm_detail.focus();
      //   });   
      //   return false;
      // }
    
      return true;
    },

    //사은품 변경 확인 버튼 클릭 시 
    clickOk(){

      let _this = this;

      if(!_this.giftData.isAgelocMe){
        _this.onOk();
      }else{
        _this.checkSkinCareCode();
      }

    },


    //스킨케어 코드 유무 검증 
    checkSkinCareCode(){

       let _this = this;

        _this.$showLoading();      
        _this.apiCheckSkinCareCode(_this.giftData.agmCode).then(res=>{
          
          let isSuccess = false;
          if(res.status === 200){

            if(res.data.result) {
              isSuccess = true;
              _this.onOk();
            }
          }
          
          if(!isSuccess){
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;

            _this.$dialogs.alert(errMsg).then(res => {});  
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});  

        }).finally(()=>{
          //hide loading
          _this.$hideLoading();
        });
    }

  }
};
</script>


// WEBPACK FOOTER //
// src/components/popup/FourPlusGiftDialog.vue